module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@3x-2e8e118c63166ef3bece63ba376206d5.png";